"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.AdUnitService = void 0;
//ANGULAR2 BITS
const core_1 = require("@angular/core");
//EXTERNAL LIBRARY BITS
const token_service_1 = require("./token.service");
const permission_service_1 = require("./permission.service");
let AdUnitService = class AdUnitService {
    constructor(_http, _permission) {
        this._http = _http;
        this._permission = _permission;
        this.adUnitURL = '/adunit';
        this.permission = [];
        this.permission = this._permission.get();
    }
    deleteAdUnit(adUnitId) {
        console.log('delete ad Unit', adUnitId);
        return this._http.delete(`${this.adUnitURL}/${adUnitId}`).toPromise();
    }
};
exports.AdUnitService = AdUnitService;
exports.AdUnitService = AdUnitService = __decorate([
    (0, core_1.Injectable)(),
    __metadata("design:paramtypes", [token_service_1.TokenService,
        permission_service_1.PermissionService])
], AdUnitService);
//# sourceMappingURL=ad-unit.service.js.map